'use client';

import React from 'react';
import styles from '@/styles/RoomNameInfo.module.css';

export function RoomNameWithDescription({
  name,
  description,
}: {
  name: string;
  description?: string;
}) {
  const [open, setOpen] = React.useState(false);
  const id = React.useId();
  const wrapperRef = React.useRef<HTMLSpanElement>(null);
  React.useEffect(() => {
    const closeWhenOutside = (event: PointerEvent) => {
      if (!wrapperRef.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('pointerdown', closeWhenOutside);
    return () => document.removeEventListener('pointerdown', closeWhenOutside);
  }, []);
  if (!description) return <span>{name}</span>;
  return (
    <span
      ref={wrapperRef}
      className={styles.wrapper}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <span>{name}</span>{' '}
      <button
        type="button"
        className={styles.trigger}
        aria-expanded={open}
        aria-controls={id}
        aria-label="Show meeting room description"
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((value) => !value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setOpen(false);
        }}
      >
        ⓘ
      </button>
      {open && (
        <span id={id} role="tooltip" className={styles.tooltip}>
          {description}
        </span>
      )}
    </span>
  );
}
